/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: N95iCQc4Yis5

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import FooterTopNav from "../../FooterTopNav"; // plasmic-import: xjflvWz4bB4Q/component
import FooterTopDownload from "../../FooterTopDownload"; // plasmic-import: ub5TK1CVdqAT/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicFooterTop.module.css"; // plasmic-import: N95iCQc4Yis5/css

createPlasmicElementProxy;

export type PlasmicFooterTop__VariantMembers = {};
export type PlasmicFooterTop__VariantsArgs = {};
type VariantPropType = keyof PlasmicFooterTop__VariantsArgs;
export const PlasmicFooterTop__VariantProps = new Array<VariantPropType>();

export type PlasmicFooterTop__ArgsType = { onContactClick?: () => void };
type ArgPropType = keyof PlasmicFooterTop__ArgsType;
export const PlasmicFooterTop__ArgProps = new Array<ArgPropType>(
  "onContactClick"
);

export type PlasmicFooterTop__OverridesType = {
  footerTop?: Flex__<"div">;
  footerTopNav?: Flex__<typeof FooterTopNav>;
  footerTopDownload?: Flex__<typeof FooterTopDownload>;
};

export interface DefaultFooterTopProps {
  onContactClick?: () => void;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicFooterTop__RenderFunc(props: {
  variants: PlasmicFooterTop__VariantsArgs;
  args: PlasmicFooterTop__ArgsType;
  overrides: PlasmicFooterTop__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"footerTop"}
      data-plasmic-override={overrides.footerTop}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.footerTop
      )}
    >
      <FooterTopNav
        data-plasmic-name={"footerTopNav"}
        data-plasmic-override={overrides.footerTopNav}
        className={classNames("__wab_instance", sty.footerTopNav)}
        onContactClick={args.onContactClick}
      />

      <FooterTopDownload
        data-plasmic-name={"footerTopDownload"}
        data-plasmic-override={overrides.footerTopDownload}
        className={classNames("__wab_instance", sty.footerTopDownload)}
      />
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  footerTop: ["footerTop", "footerTopNav", "footerTopDownload"],
  footerTopNav: ["footerTopNav"],
  footerTopDownload: ["footerTopDownload"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  footerTop: "div";
  footerTopNav: typeof FooterTopNav;
  footerTopDownload: typeof FooterTopDownload;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicFooterTop__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicFooterTop__VariantsArgs;
    args?: PlasmicFooterTop__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicFooterTop__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicFooterTop__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicFooterTop__ArgProps,
          internalVariantPropNames: PlasmicFooterTop__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicFooterTop__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "footerTop") {
    func.displayName = "PlasmicFooterTop";
  } else {
    func.displayName = `PlasmicFooterTop.${nodeName}`;
  }
  return func;
}

export const PlasmicFooterTop = Object.assign(
  // Top-level PlasmicFooterTop renders the root element
  makeNodeComponent("footerTop"),
  {
    // Helper components rendering sub-elements
    footerTopNav: makeNodeComponent("footerTopNav"),
    footerTopDownload: makeNodeComponent("footerTopDownload"),

    // Metadata about props expected for PlasmicFooterTop
    internalVariantProps: PlasmicFooterTop__VariantProps,
    internalArgProps: PlasmicFooterTop__ArgProps
  }
);

export default PlasmicFooterTop;
/* prettier-ignore-end */
